import { Box, styled } from '@mui/material';
import Sunset from '../assets/images/bg.jpg';
import Form from '../components/Form';
import Information from '../components/Information';

import { useState } from 'react';

const Component = styled(Box)({
    height: '100vh',
    display: 'flex',
    alignItems:'center',
    margin: '0 auto',
    width: '65%', //change this to edit the look
})

const Image= styled(Box)({
    backgroundImage: `url(${Sunset})`,
    width: '25%',
    height: '70%',
    backgroundSize: 'cover',
    borderRadius: '10px 0 0 10px',
})

const Home = () => {

    //for fetching the common data from form and displaying into information
    const [result, setResult ] = useState({})

    return (
        <Component>
            <Image></Image>
            <Box style={{
                width: '75%',
                height: '70%',
                borderRadius: '0 10px 10px 0'
            }}>
                <Form setResult={setResult} />
                <Information result={result} />
            </Box>
        </Component>
    )
}

export default Home;